import { Pipe, PipeTransform } from '@angular/core';
import { formatDateTime } from '../helper';

@Pipe({
  name: 'formatDate',
  pure: true,
})
export class DatePipe implements PipeTransform {
  transform(date: string): string {
    return formatDateTime(date);
  }
}
